export default {"src":"/_next/static/media/parking-pickup.270b3a18.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};